const TENANT_ROLE_LEVEL = {
    agent: 0,
    supervisor: 1,
    admin: 2,
    owner: 3,
};
export function canOpenTenantMemberProfile(actorRole, targetRole, isSelf) {
    if (isSelf || actorRole === 'owner')
        return true;
    return TENANT_ROLE_LEVEL[actorRole] > TENANT_ROLE_LEVEL[targetRole];
}
export function canDeleteTenantMember(actorRole, targetRole, isSelf) {
    return !isSelf && TENANT_ROLE_LEVEL[actorRole] > TENANT_ROLE_LEVEL[targetRole];
}
export function canInviteTenantMember(actorRole, invitedRole) {
    if (actorRole !== 'owner' && actorRole !== 'admin')
        return false;
    return invitedRole !== 'owner';
}
//# sourceMappingURL=tenant-roles.js.map